(() => {
  /**
   * Safely round all Judge.me badges to 1 decimal
   * Zero render-blocking, zero long tasks, runs in idle time
   */
  const roundJudgeMeRatings = () => {
    requestIdleCallback(() => {
      document.querySelectorAll('.jdgm-prev-badge').forEach(badge => {
        const avg = parseFloat(badge.dataset.averageRating);
        if (isNaN(avg)) return;

        const rounded = Math.round(avg * 10) / 10;
        badge.dataset.averageRating = rounded;

        const stars = badge.querySelector('[data-score]');
        if (stars) {
          stars.dataset.score = rounded;
          stars.setAttribute('aria-label', `${rounded} stars`);
        }

        // Optional: update visible number if it appears in text
        const textEl = badge.querySelector('.jdgm-prev-badge__text');
        if (textEl && /\d+\.\d+/.test(textEl.textContent)) {
          textEl.textContent = textEl.textContent.replace(/\d+\.\d+/, rounded.toFixed(1));
        }
      });
    }, { timeout: 800 }); // run in idle time, avoids blocking
  };

  /**
   * Run only when badges are actually present (Judge.me loads async)
   */
  const tryRun = () => {
    if (document.querySelector('.jdgm-prev-badge')) {
      roundJudgeMeRatings();
    } else {
      // Retry a few times in the background (non-blocking)
      setTimeout(tryRun, 400);
    }
  };

  // Run once DOM is ready (but defer heavy work)
  window.addEventListener('DOMContentLoaded', () => {
    // Run quietly in background
    requestIdleCallback(tryRun, { timeout: 1000 });

    // If Judge.me triggers ready event
    document.addEventListener('jdgm.ready', () => requestIdleCallback(tryRun, { timeout: 800 }));

    // On AJAX / infinite scroll reloads
    document.addEventListener('ajaxinate:loaded', () => requestIdleCallback(tryRun, { timeout: 800 }));

    // Use light observer to re-run only when new badges appear
    const observer = new MutationObserver((mutations) => {
      for (const m of mutations) {
        if ([...m.addedNodes].some(n => n.nodeType === 1 && n.classList?.contains('jdgm-prev-badge'))) {
          requestIdleCallback(roundJudgeMeRatings, { timeout: 800 });
          break;
        }
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  });
})();